import React, { useEffect, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { runInAction } from 'mobx';
import { useMeasure } from 'react-use';

const ProcessBar = observer((props) => {
  const {
    className = '',
    text = '',
    time = 10,  // 预估时长(s)
    maxProcess = 99,  // 最大显示的进度
    timeForUpdate = 100,  // 每 xms 更新
    rndUpdate = 2, // 更新过程中取随机值
    finished = false,
  } = props;

  const [$refContainer, { width: widthContainer }] = useMeasure();
  const store = useLocalObservable(() => ({
    time : 0,
    endTime : 0,
    process : 0,
    timer : null,

    init (time) {
      this.time = (parseInt(time, 10) || 10) * 1000;
      this.endTime = (+new Date) + this.time;
      this.timer = setInterval(() => {
        this.increase();
      }, timeForUpdate);
    },

    increase () {
      const now = +new Date;
      if(now >= this.endTime || this.process >= maxProcess){
        clearInterval(this.timer);
        return;
      }

      const processPerUpdate = 100 / this.time * timeForUpdate;
      const delta = HelperCore.getRnd(Math.max(0, processPerUpdate - rndUpdate * (10 / time)), processPerUpdate + rndUpdate * (10 / time));
      runInAction(() => {
        this.process = Math.min(maxProcess, this.process + delta);
      });
    },

    setFinished () {
      clearInterval(this.timer);
      this.process = 100;
    }
  }));
  useEffect(() => {
    store.init(time);

    return () => {
      clearInterval(store.timer);
    }
  }, []);
  useEffect(() => {
    if(finished){
      store.setFinished();
    }
  }, [finished]);

  return (
    <div 
      className={`flex w-full ${className}`}
      ref={$refContainer}>
      {
        text
        ? (
          <div className="text-black opacity-50 text-12px text-center leading-17px mb-12px">{text}</div>
        )
        : null
      }
      <div 
        className="w-full h-2px rounded-full relative overflow-hidden"
        style={{
          width: `${store.process}%`,
          transition: "width ease-in-out .25s",
        }}
        >
        <div 
          className="absolute h-full top-0 left-0 rounded-full"
          style={{
            background: "linear-gradient(90deg, #ADC841 0%, #5DEFB6 19.71%, #5640FF 44.23%, #B550FF 65.38%, #FCAC57 82.21%, #ADC841 99.04%)",
            width: widthContainer,
          }}
          >
        </div>
      </div>
    </div>
  )
});
export default ProcessBar;